module.exports = __webpack_public_path__ + "static/media/arts_15.2f54b54f.jpg";